'use client'

import { useMemo } from 'react'

import { BannerTypes } from '../../../submodules/banners/api'

import BannerSlider from './BannerSlider'

import styles from './BannersSection.module.scss'

interface BannerSectionProps {
  banners: BannerTypes[]
}

const BannersSection = ({ banners }: BannerSectionProps) => {
  const mainSectionBanners = useMemo(() => {
    return banners.filter(
      banner => banner.section === 'main' && banner.side === 'left'
    )
  }, [banners])

  return (
    <section className={styles.wrapper}>
      <BannerSlider
        banners={mainSectionBanners}
        creativeSlotSeoPrefix='main_page_big'
      />
    </section>
  )
}

export default BannersSection
